import { usePlayerCoins } from "@/hooks/usePlayerCoins";
import { useRewardConfig } from "@/hooks/useRewardConfig";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { format } from "date-fns";
import { sv } from "date-fns/locale";
import { Coins } from "lucide-react";

const typeLabels: Record<string, string> = {
  earned_booking: "Bokning",
  earned_match: "Match",
  earned_tournament: "Turnering",
  earned_manual: "Bonus",
  spent_reward: "Inlöst",
  admin_adjustment: "Justering",
};

export default function PlayerCoinsCard() {
  const { balance, lifetimeEarned, transactions } = usePlayerCoins();
  const { isEnabled } = useRewardConfig();

  if (!isEnabled) return null;

  const recent = transactions.slice(0, 5);

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-lg flex items-center gap-2">
          <Coins className="h-5 w-5 text-amber-500" /> Mina coins
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center gap-4">
          <div className="text-3xl font-bold text-amber-600 dark:text-amber-400">
            {balance} 🪙
          </div>
          <div className="text-xs text-muted-foreground">
            Totalt intjänat: {lifetimeEarned}
          </div>
        </div>

        {recent.length > 0 && (
          <div className="space-y-1.5">
            <p className="text-xs font-medium text-muted-foreground">Senaste transaktioner</p>
            {recent.map((tx: any) => (
              <div key={tx.id} className="flex items-center justify-between text-sm">
                <div className="flex items-center gap-2">
                  <Badge variant={tx.amount > 0 ? "default" : "secondary"} className="text-xs px-1.5 py-0">
                    {tx.amount > 0 ? `+${tx.amount}` : tx.amount}
                  </Badge>
                  <span className="text-muted-foreground">{typeLabels[tx.type] ?? tx.type}</span>
                </div>
                <span className="text-xs text-muted-foreground">
                  {format(new Date(tx.created_at), "d MMM", { locale: sv })}
                </span>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
